import React, { useState } from 'react';
import { LegalModal } from './LegalModal';
import { ShieldCheckIcon, FileTextIcon } from 'lucide-react';
export function FooterSection() {
  const [privacyOpen, setPrivacyOpen] = useState(false);
  const [termsOpen, setTermsOpen] = useState(false);
  return <footer className="py-12 px-6 text-center border-t border-charcoal/10 mt-12" data-id="element-106">
      <div className="max-w-3xl mx-auto" data-id="element-107">
        <p className="text-charcoal/50 text-sm mb-4 leading-relaxed" data-id="element-108">
          Descargo de responsabilidad: La información proporcionada en este
          programa tiene fines educativos y no sustituye el consejo, diagnóstico
          o tratamiento médico profesional. Siempre busca el consejo de tu
          médico u otro proveedor de salud calificado con cualquier pregunta que
          puedas tener sobre una condición médica.
        </p>

        {/* Legal Links */}
        <div className="flex items-center justify-center gap-6 mb-4" data-id="element-109">
          <button onClick={() => setPrivacyOpen(true)} className="inline-flex items-center gap-1.5 text-charcoal/50 hover:text-sage transition-colors text-sm focus:outline-none focus:underline" data-id="element-110">
            <ShieldCheckIcon className="w-4 h-4" data-id="element-111" />
            Política de Privacidad
          </button>
          <span className="text-charcoal/20" data-id="element-112">|</span>
          <button onClick={() => setTermsOpen(true)} className="inline-flex items-center gap-1.5 text-charcoal/50 hover:text-sage transition-colors text-sm focus:outline-none focus:underline" data-id="element-113">
            <FileTextIcon className="w-4 h-4" data-id="element-114" />
            Términos y Condiciones
          </button>
        </div>

        <p className="text-charcoal/60 text-sm" data-id="element-115">
          © {new Date().getFullYear()} Método Cero Cortisol. Todos los derechos
          reservados.
        </p>
      </div>

      {/* Privacy Policy Modal */}
      <LegalModal isOpen={privacyOpen} onClose={() => setPrivacyOpen(false)} title="Política de Privacidad" data-id="element-116">
        <p className="font-semibold text-charcoal" data-id="element-117">
          Última actualización: Marzo 2026
        </p>

        <p data-id="element-118">
          En Método Cero Cortisol, respetamos y protegemos tu privacidad. Esta
          política describe cómo recopilamos, usamos y protegemos tu información
          personal.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-119">
          1. Información que Recopilamos
        </h3>
        <p data-id="element-120">
          Recopilamos únicamente la información necesaria para procesar tu
          compra y entregarte el producto:
        </p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-121">
          <li data-id="element-122">Nombre completo</li>
          <li data-id="element-123">Dirección de correo electrónico</li>
          <li data-id="element-124">
            Información de pago (procesada de forma segura por nuestro proveedor
            de pagos)
          </li>
        </ul>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-125">
          2. Uso de la Información
        </h3>
        <p data-id="element-126">Tu información se utiliza exclusivamente para:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-127">
          <li data-id="element-128">Procesar y entregar tu compra</li>
          <li data-id="element-129">Enviarte el acceso al material adquirido</li>
          <li data-id="element-130">Comunicarnos contigo sobre tu pedido</li>
          <li data-id="element-131">
            Enviarte actualizaciones del producto (solo si das tu
            consentimiento)
          </li>
        </ul>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-132">
          3. Protección de Datos
        </h3>
        <p data-id="element-133">
          Implementamos medidas de seguridad técnicas y organizativas para
          proteger tu información personal contra acceso no autorizado, pérdida
          o alteración. Nunca vendemos, alquilamos ni compartimos tu información
          personal con terceros con fines de marketing.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-134">4. Cookies</h3>
        <p data-id="element-135">
          Nuestro sitio puede utilizar cookies esenciales para el funcionamiento
          del sitio y cookies analíticas para mejorar tu experiencia. Puedes
          desactivar las cookies en la configuración de tu navegador.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-136">
          5. Tus Derechos
        </h3>
        <p data-id="element-137">Tienes derecho a:</p>
        <ul className="list-disc pl-5 space-y-1" data-id="element-138">
          <li data-id="element-139">Acceder a tu información personal</li>
          <li data-id="element-140">Solicitar la corrección de datos inexactos</li>
          <li data-id="element-141">Solicitar la eliminación de tus datos</li>
          <li data-id="element-142">Retirar tu consentimiento en cualquier momento</li>
        </ul>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-143">6. Contacto</h3>
        <p data-id="element-144">
          Para cualquier consulta sobre tu privacidad, puedes escribirnos a
          nuestro correo de soporte. Responderemos en un plazo máximo de 48
          horas.
        </p>
      </LegalModal>

      {/* Terms & Conditions Modal */}
      <LegalModal isOpen={termsOpen} onClose={() => setTermsOpen(false)} title="Términos y Condiciones" data-id="element-145">
        <p className="font-semibold text-charcoal" data-id="element-146">
          Última actualización: Marzo 2026
        </p>

        <p data-id="element-147">
          Al adquirir el Método Cero Cortisol, aceptas los siguientes términos y
          condiciones de uso.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-148">
          1. Producto Digital
        </h3>
        <p data-id="element-149">
          El Método Cero Cortisol es un producto digital educativo que incluye
          guías en PDF, audio-guías y material complementario. El acceso se
          entrega de forma inmediata tras la confirmación del pago a través de
          correo electrónico.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-150">
          2. Uso Personal
        </h3>
        <p data-id="element-151">
          El material adquirido es para uso personal y exclusivo del comprador.
          Queda prohibida la reproducción, distribución, reventa o compartición
          del contenido sin autorización expresa por escrito.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-152">
          3. Descargo de Responsabilidad Médica
        </h3>
        <p data-id="element-153">
          El contenido de este programa tiene fines exclusivamente educativos e
          informativos. No constituye consejo médico, diagnóstico ni tratamiento
          profesional. Las técnicas presentadas se basan en principios de
          neurobiología y regulación del sistema nervioso, pero no sustituyen la
          atención médica profesional.
        </p>
        <p data-id="element-154">
          Si padeces una condición médica o psicológica diagnosticada, consulta
          con tu profesional de salud antes de aplicar cualquier técnica del
          programa.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-155">
          4. Política de Reembolso
        </h3>
        <p data-id="element-156">
          Ofrecemos una garantía de satisfacción de 30 días. Si después de
          aplicar el método sientes que no te ha sido útil, puedes solicitar un
          reembolso completo contactándonos por correo electrónico dentro de los
          30 días posteriores a tu compra.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-157">
          5. Propiedad Intelectual
        </h3>
        <p data-id="element-158">
          Todo el contenido del Método Cero Cortisol, incluyendo textos, audios,
          gráficos y diseños, está protegido por derechos de autor. Cualquier
          uso no autorizado será perseguido conforme a la ley aplicable.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-159">
          6. Modificaciones
        </h3>
        <p data-id="element-160">
          Nos reservamos el derecho de modificar estos términos en cualquier
          momento. Los cambios serán efectivos desde su publicación en esta
          página. Te recomendamos revisar estos términos periódicamente.
        </p>

        <h3 className="font-bold text-charcoal text-base mt-6" data-id="element-161">7. Contacto</h3>
        <p data-id="element-162">
          Para cualquier duda sobre estos términos, puedes contactarnos a través
          de nuestro correo de soporte. Nos comprometemos a responder en un
          plazo máximo de 48 horas.
        </p>
      </LegalModal>
    </footer>;
}